import { render } from "./moduleBindings.vue?vue&type=template&id=67b55cd1&scoped=true"
import script from "./moduleBindings.vue?vue&type=script&lang=js"
export * from "./moduleBindings.vue?vue&type=script&lang=js"

import "./moduleBindings.vue?vue&type=style&index=0&id=67b55cd1&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\horva\\Documents\\nodejs\\production\\enat05\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67b55cd1"]])

export default __exports__